import type { YNValue } from '../types';

import s from './YNToggle.module.scss';

interface YNToggleProps {
  value: YNValue;
  onToggle: (v: 'Y' | 'N') => void;
}

export function YNToggle({ value, onToggle }: YNToggleProps) {
  return (
    <div className={s.container}>
      <button
        className={`${s.btn} ${value === 'Y' ? s.active : ''} ${s.yes}`}
        onClick={() => onToggle('Y')}
      >
        Y
      </button>
      <button
        className={`${s.btn} ${value === 'N' ? s.active : ''} ${s.no}`}
        onClick={() => onToggle('N')}
      >
        N
      </button>
    </div>
  );
}
